/**
 * Constants used by multiple components/modules
 * @namespace constants
 */

/**
 * The maximum image upload size (4.5mb) in bytes, to be passed into omni image
 * upload components.
 * @memberof constants
 * @type {number}
 * @constant
 */
export const MAX_IMAGE_BYTE_SIZE = 1024 ** 2 * 4.5;

/**
 * Base URL for 3rd party script locations on the CDN
 * @memberof constants
 * @type {string}
 * @constant
 */
export const CDN_DEPENDENCIES_BASE =
  'https://campaign-cdn.annalect.com/dependencies/';

/**
 * Default image URL for new campaigns
 * @memberof constants
 * @type {string}
 * @constant
 */
export const DEFAULT_CAMPAIGN_IMG_URL =
  'https://images.annalect.com/image/eyJrZXkiOiAiNDkwZjI3Mzc2MzIxZjRlZGNjNzA0YzMyYjcwMzllZjEwMTZhZGRhZTk2YTcxY2I5MTYwNjkzODIwNDgyNSJ9#default.png';

/**
 * A base64 image string for a transparent gif pixel
 * @memberof constants
 * @type {string}
 * @constant
 */
export const TRANSPARENT_PIXEL_IMG_DATA =
  'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

export const AUDIENCE_INSIGHTS_DEFAULT = {
  fields: {
    output: {
      label: 'Output',
      tooltip:
        'What do they need to DO? What do they need to do differently? What job(s) do they want or need to get done? What decision(s) do they need to make? How will we know they were successful?',
      tooltipPosition: 'top',
    },
    pains: {
      label: 'Pains',
      tooltip: 'What are their fears, frustrations, and anxieties?',
      tooltipPosition: 'top',
    },
    gains: {
      label: 'Gains',
      tooltip: 'What are their wants, needs, hopes, and dreams?',
      tooltipPosition: 'top',
    },
  },
  areas: {
    thinks: {
      label: 'Think | Feel',
      popoverPosition: 'center',
      tooltip:
        'Who is the person we want to understand? What is the situation they are in? What is their role in the situation? What other thoughts and feelings might motivate their behavior?',
      tooltipPosition: 'bottom',
    },
    hears: {
      label: 'Hears',
      popoverPosition: 'left',
      tooltip:
        'What do they HEAR? What are they hearing others say? What are they hearing from friends? What are they hearing from colleagues? What are they hearing second hand?',
      tooltipPosition: 'right',
    },
    sees: {
      label: 'Sees',
      popoverPosition: 'right',
      tooltip:
        'What do they SEE? What do they see in the marketplace? What do they see in their immediate environment? What  do they see others saying and doing? What are they watching and reading?',
      tooltipPosition: 'left',
    },
    says: {
      label: 'Says',
      popoverPosition: 'right',
      tooltip:
        'What do they SAY? What have we heard them say? What can we imagine them saying?',
      tooltipPosition: 'left',
    },
    does: {
      label: 'Does',
      popoverPosition: 'left',
      tooltip:
        'What do they DO? What do they do today? What behavior have we observed? What can we imagine them doing?',
      tooltipPosition: 'right',
    },
  },
  title: 'Audience Insights',
};

export const EMPATHY_MAP_DEFAULT = {
  bottom: {
    middle: 'Relevance',
  },
  dropdownOptions: [
    {
      label: 'Task',
      textColor: 'rgb(var(--rgb-core-light))',
      value: 'rgb(var(--rgb-core-dark))',
    },
    {
      label: 'Audience',
      textColor: 'rgb(var(--rgb-core-light))',
      value: 'rgb(var(--rgb-core-medium))',
    },
    {
      label: 'Delivery',
      textColor: 'rgb(var(--rgb-core-dark))',
      value: 'rgb(var(--rgb-core-medium-two))',
    },
    {
      label: 'Channels',
      textColor: 'rgb(var(--rgb-core-dark))',
      value: 'rgb(var(--rgb-core-light))',
    },
  ],
  middle: {
    left: 'Broadcast',
    right: 'Addressable',
  },
  subtitle: {
    left: 'Known Audiences',
    middle: 'Reach',
    right: 'Known Audiences',
  },
  yAxisLabel: '',
  title: '1. Known and Unknown Audiences',
  quadrantData: {
    viz1: [],
    viz2: [],
    viz3: [],
    viz4: [],
  },
};
